import InteractsWithState from './InteractsWithState';
import { IO, Api } from 'src/utilities';
import Stash from 'src/stash';

export default {
  mixins: [InteractsWithState],

  methods: {
    toggleStockStatus(persist = true) {
      this.product.in_stock = !this.product.in_stock;

      const payload = _.pick(this.product, ['id', 'in_stock']);
      console.log(payload);
      IO.emit(`sfu.stores.${this.state.store.id}`, 'product.updated', payload);
      Stash.updateProduct(payload.id, payload);

      if (!persist) {
        return;
      }

      Api.put(`products/${this.product.id}/stock`).catch(() =>
        this.toggleStockStatus(false)
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/TogglesStockStatus.js